import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss']
})
export class MessageModalComponent implements OnInit {

  title: string;
  text: string;
  isSuccesful: boolean;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    console.log(this.isSuccesful);

  }

}
